import { useEffect, useState } from 'react'
import { DateTime } from 'luxon'
import { getGeneralInfo } from './generalInfo'

const TIMEZONE = 'Europe/Chisinau'

function at(time: string | undefined, fallbackHour: number) {
  const [hour, minute] = (time || '').split(':')
  return DateTime.now()
    .setZone(TIMEZONE)
    .set({
      hour: Number(hour || fallbackHour),
      minute: Number(minute || 0),
      second: 0,
    })
}

export function computeIsOutsideHours(): boolean {
  const info = getGeneralInfo()
  const now = DateTime.now().setZone(TIMEZONE)
  return now < at(info.minTime, 10) || now > at(info.maxTime, 23)
}

export function useStoreHours() {
  const info = getGeneralInfo()
  const [isOutsideHours, setIsOutsideHours] = useState(computeIsOutsideHours)

  useEffect(() => {
    const id = window.setInterval(
      () => setIsOutsideHours(computeIsOutsideHours()),
      60_000,
    )
    return () => window.clearInterval(id)
  }, [])

  return {
    minTime: info.minTime,
    maxTime: info.maxTime,
    isDayOff: !!info.dayOff,
    isOutsideHours,
    isOpen: !isOutsideHours && !info.dayOff,
  }
}
